export default function cardAnimation() {
  let areaCardAnimation = document.querySelectorAll('.js-card-animation');
  let bannerCard = document.querySelectorAll('.js-banner-card');

  areaCardAnimation.forEach((item, index) => {
    let animationMousemovePlace = document.querySelectorAll('.js-place-animation')[index].getBoundingClientRect();

    item.addEventListener('mousemove', function (e) {
      if (animationMousemovePlace.x < e.pageX && e.pageX < animationMousemovePlace.x + animationMousemovePlace.width) {
        let centerX = e.pageX - animationMousemovePlace.x - animationMousemovePlace.width / 2;
        let degX = (centerX * 0.02).toFixed(3);

        bannerCard[index].style = `--progress: ${degX}; --transition-duration: 0.2s`;
      } else {
        let getRotateValue = +getComputedStyle(bannerCard[index]).getPropertyValue('--progress');

        // Left
        if (e.pageX < animationMousemovePlace.x) {
          if (getRotateValue > -14) {
            bannerCard[index].style = `--progress: ${(getRotateValue - 4).toFixed(3)}; --transition-duration: 0.4s`;
          }
        } else {
          // Right
          if (getRotateValue < 12) {
            bannerCard[index].style = `--progress: ${(getRotateValue + 4).toFixed(3)}; --transition-duration: 0.4s`;
          }
        }
      }
    });
  });
}
